import { uncurlyUuid } from '@atlassian/bitkit-analytics';

export const FORGE_PRODUCT = 'bitbucket';

export const constructBitbucketWorkspaceAri = (
  workspaceUuid?: string
): string => {
  const uuid = workspaceUuid ?? '';
  const unwrappedUuid = uncurlyUuid(uuid);
  if (!unwrappedUuid) {
    return '';
  }
  return `ari:cloud:bitbucket::workspace/${uncurlyUuid(uuid)}`;
};
